var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"das-info-list",class:{
    'das-info-list--align-center': _vm.alignType === 'center',
    'das-info-list--align-start': _vm.alignType === 'start'
  },style:(`
      --das-info-list-columns: ${_vm.columns};
      --das-info-list-columns-sm: ${_vm.columnBreakpoints.sm};
      --das-info-list-columns-md: ${_vm.columnBreakpoints.md};
      --das-info-list-columns-lg: ${_vm.columnBreakpoints.lg};
      --das-info-list-columns-xl: ${_vm.columnBreakpoints.xl};
      --das-info-list-columns-2xl: ${_vm.columnBreakpoints['2xl']};
    `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }